<div class="container-fluid px-4 pb-4">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="mb-0 text-secondary">Empty Trailer Aging</h4>
                </div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-date-range-box [multiView]="false" [showClearButton]="true" [(value)]="dateRangeFilterValue" (onValueChanged)="onDateRangeChanged($event)" stylingMode="filled"></dx-date-range-box>
                    <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                </div>
            </div>

            <div class="row align-items-center mb-4">
                <div class="col-sm-8 text-center position-relative">
                    <app-doughnut-chart
                        [from]="fromDate"
                        [to]="toDate"
                        [centerText]="'My Score'"
                        [useCapitalCaseFormatting]="false"
                        (loaded)="onMainChartLoaded($event)"
                        [loadData]="loadMainScoreData"
                        [formatMode]="'percent'"
                        [palette]="mainPalette">
                    </app-doughnut-chart>
                </div>

                <div class="col-sm-4 col-xl-3 offset-xl-1">
                    <div class="table-responsive rounded-1 border border-1">
                        <table class="table table-borderless mb-0">
                            <thead class="bg-light text-muted small text-uppercase">
                            <tr class="table-light">
                                <th>Type</th>
                                <th>INSTANCES</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (detail of scoreData; track detail) {
                                    <tr class="border-top">
                                        <td class="text-muted">{{ detail.argument }}</td>
                                        <td class="text-muted">{{ detail.value }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4">
        <div class="col-12 col-lg-6">
            <app-score-breakdown-chart
                [title]="'Required'"
                [score]="requiredItem"
                [centerText]="'Trailers'"
                [formatMode]="'decimal'"
                [useCapitalCaseFormatting]="false"
                [colorMode]="'index'"
                [legendRowCount]="3"
            ></app-score-breakdown-chart>
        </div>
        <div class="col-12 col-lg-6">
            <app-score-breakdown-chart
                [title]="'Not Required'"
                [score]="notRequiredItem"
                [centerText]="'Trailers'"
                [formatMode]="'decimal'"
                [useCapitalCaseFormatting]="false"
                [colorMode]="'index'"
                [legendRowCount]="3"
            ></app-score-breakdown-chart>
        </div>
    </div>
</div>